<template>
	<screen class="settings-view">
		<template slot="header">
			<ui-header type="dark" @click="onBack">
				<h2 slot="title">Legal</h2>
			</ui-header>
		</template>
		<div class="settings-inner">
			<div class="settings-row">
				<blank-tile
					@click.native="external('https://roundupapp.com/terms')"
				>
					<span slot="title">Terms of Use</span>
				</blank-tile>
				<blank-tile
					@click.native="external('https://roundupapp.com/privacy')"
				>
					<span slot="title">Privacy Policy</span>
				</blank-tile>
			</div>
		</div>
	</screen>
</template>

<script>
import Screen from '../../ui/Screen'
import BlankTile from '../Main/BlankTile'
import UiHeader from '../../ui/Header'

export default {
	name: 'legal-view',
	components: { Screen, UiHeader, BlankTile },
	methods: {
		external(url) {
			window.location = url
		},
		onBack() {
			this.navigate({ name: 'settings' }, 'back')
		}
	}
}
</script>

<style lang="scss">
.settings-view {
	overflow: hidden;
	position: relative;
	.settings-inner {
		position: relative;
		margin-left: -35px;
		margin-right: -35px;
		padding: 10px 10px 0;
		z-index: 1;
		@media screen and (max-width: 480px) {
			margin-left: -25px;
			margin-right: -25px;
		}
		.settings-row {
			display: grid;
			grid-template-columns: 1fr 1fr;
			grid-column-gap: 10px;
		}
	}
}
</style>
